export default __webpack_public_path__ + "static/media/create-job.b58a01df.png";